module.exports = __webpack_public_path__ + "img/epicerie-en-ligne-boutrais.30bb2b9a.png";